import { Typography } from "@mui/material";
import React from "react";

export function EmptyDataDiv({ message }) {
    return <div className="m-2">
        <center>
            <Typography>{message}</Typography>
        </center>
    </div>
}